import { useState } from 'react'
import gallerySnip from '../../assets/code-snippets/gallery/dynamicSnip'
import Snippet from '../../components/Snippet/Snippet'

const Gallery = () => {

    const [gLayout, setGLayout] = useState('row')
    let gallery = gallerySnip(gLayout)
    const helper = (e) => setGLayout(e)

    return <div className="container fluid py-2" id="intro">

        <div className="container xl">
            <p className="text xl"><a href="#intro" className="link">&#128279;</a> Images gallery</p>
            <p className="text md"> Gallery is a collection of images grouped in a fashioned manner in a web page, construction of one
                of this galleries is implemented by HTML & CSS only, no JavaScript is required at this point, different classes applied to parent element will change images displaying behaviour.</p>
        </div>
        <div className="spacer md"></div>
        <div className="row">
            <div className="col md-III">
                <p className="text lg primary">Example</p>
                <div className="container sm px-5">
                    <div className="form-group md">
                        <div className="form-item">
                            <label>Gallery layout</label>
                            <select onChange={(e) => helper(e.target.value)}>
                                <option value="row">.row</option>
                                <option value="row gap-10">.row.gap-10</option>
                                <option value="row right">.row.right</option>
                                <option value="row left">.row.left</option>
                                <option value="masonry">.masonry</option>
                                <option value="masonry bordered">.masonry.bordered</option>
                                <option value="masonry no-gutter">.masonry.no-gutter</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="container fluid">
                    {<div dangerouslySetInnerHTML={{ __html: gallery }}></div>}
                </div>

            </div>
            <div className="col md-III">
                <p className="text lg primary">Template</p>
                <div className="container fluid">
                    <Snippet code={gallery} language='html' />
                </div>
            </div>
        </div>
    </div>
}

export default Gallery